import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52a61c3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-banner__background" }, null, -1))
const _hoisted_2 = { class: "auth-banner__title" }
const _hoisted_3 = {
  key: 0,
  class: "auth-banner__coming-soon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/fire-icon.svg",
  alt: ""
}, null, -1))

import { useInternalization } from '@/composables/useInternalization';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthBanner',
  setup(__props) {

const router = useRouter();
const { t } = useInternalization();

const featuresList: { title: string; isComingSoon?: boolean }[] = [
  { title: t('authFeatureList[0]') },
  { title: t('authFeatureList[1]') },
  { title: t('authFeatureList[2]') },
  { title: t('authFeatureList[3]') },
  { title: t('authFeatureList[4]') },
];

function handleBannerClick() {
  router.push({ name: 'Auth' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "auth-banner",
    onClick: handleBannerClick
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('signupNow')), 1),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(featuresList, (feature) => {
      return _createElementVNode("div", {
        key: feature.title,
        class: "auth-banner__text"
      }, [
        _createElementVNode("div", null, _toDisplayString(feature.title), 1),
        (feature.isComingSoon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(t)('comingSoon')) + " ", 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ])
    }), 64))
  ]))
}
}

})